
interface Category {
  id: string;
  name: string;
  description: string;
  image_url: string;
  active: boolean;
}

interface CategoryFilterProps {
  categories: Category[];
  selectedCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

export default function CategoryFilter({ categories, selectedCategory, onCategoryChange }: CategoryFilterProps) {
  // Adicionar categoria "Todos" no início
  const allCategories = [
    { id: 'all', name: 'Todos', description: '', image_url: '', active: true },
    ...categories.filter(c => c.active)
  ];

  const getCategoryIcon = (categoryName: string) => {
    const name = categoryName.toLowerCase();
    if (name.includes('bolo')) return 'ri-cake-line';
    if (name.includes('doce') || name.includes('brigadeiro') || name.includes('beijinho')) return 'ri-heart-line';
    if (name.includes('cupcake')) return 'ri-cake-2-line';
    if (name.includes('torta')) return 'ri-cake-3-line';
    return 'ri-cake-3-line';
  };

  return (
    <div className="mb-6">
      <div className="flex space-x-2 overflow-x-auto pb-2">
        {allCategories.map(category => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`flex-shrink-0 px-4 py-2 rounded-full text-xs font-medium transition-all duration-200 flex items-center space-x-2 ${
              selectedCategory === category.id
                ? 'bg-gradient-to-r from-pink-400 to-purple-400 text-white shadow-md'
                : 'bg-white text-gray-600 border border-pink-100 hover:border-pink-200'
            }`}
          >
            <i className={`${getCategoryIcon(category.name)} text-sm`}></i>
            <span>{category.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
